// extracted by css-extract-rspack-plugin
export default {"chips":"ED6dmkfFUKQZiDz2","chip":"ArWteO2nGKoSkC23","chipActive":"sm0tyvXBE0BSoLma"};